import { HttpClient, HttpClientModule } from '@angular/common/http';
import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { environment } from 'src/environments/environment';


export function provideTranslate(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: NZ_I18N, useValue: en_US },
        TranslateStore,
        importProvidersFrom(
            TranslateModule.forRoot({
              loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
              },
            })
        ),
        importProvidersFrom(
            TranslateModule.forChild({
              loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
              },
              defaultLanguage: 'en',
            })
        ),
    ]);
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

export function createTranslateLoader(http: HttpClient) {
    const baseTranslateUrl = './assets/i18n/';
    return new TranslateHttpLoader(http, baseTranslateUrl, '.json');
  }